// file_to_parquet strategy (file → parquet_raw): downloads + converts source
// files to raw parquet. Read-only info panel (no per-instance config yet).
import { registerStrategyKind } from "../registry";

function FileToParquetPanel() {
  return (
    <div className="p-6">
      <h2 className="text-lg font-semibold mb-1">File → Parquet transformation</h2>
      <p className="text-sm text-gray-500 max-w-2xl">
        file → parquet_raw. Downloads the source file(s) from S3 and converts
        them to raw parquet sheets. Implemented by the opaque Flow endpoint
        <code className="mx-1">cortex.strategy.file_to_parquet.apply</code>.
        No per-instance configuration — source files come from the connected
        file data point.
      </p>
    </div>
  );
}

registerStrategyKind("file_to_parquet", { label: "File → Parquet", Panel: FileToParquetPanel });
